import ButtonV1 from "lib/ButtonV1";
import React from "react";
import { Modal } from "react-bootstrap";
import "./index.scss";

function ConfirmModal(props) {
  const {  onHide, title,subHeading,handleConfirm ,editFontSize} = props;
  return (
    <Modal className="containermodal" {...props} size="md" centered>
      <Modal.Header closeButton className="pb-0">
        <Modal.Title className="semiBoldForvalue fs-22px" id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="semiBoldForvalue pt-0">
        {subHeading && <h4 className={`text-center mb-5 ${editFontSize ? editFontSize:''}`}>{subHeading}</h4>}
        <div className="d-flex justify-content-end">
            <ButtonV1 label="Cancel" onClick={onHide} className="me-3 pt-2 semiBoldForvalue light_button" />
            <ButtonV1 className="semiBoldForvalue primary_button pt-2" label="Yes" onClick={handleConfirm} />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmModal;
